
export default {
    name: 'plaintes',
    components: {},
    props: ['consultation', 'is_printable'],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


